// ModifDroitSoc.js
import React, { useState } from "react";

import { Building2, AlertCircle, Loader2, Check } from "lucide-react";

import { authFetch } from '../../../../../HttpClient';

import { dialog } from "../../../../../components/ui/Dialog";
const ModifDroitSoc = ({ item, onClose, fetchData }) => {
  const [formData, setFormData] = useState({
    cedant: item.cedant || "",
    cessionnaire: item.cessionnaire || "",
    nombreDeDroit: item.nombreDeDroit || "",
    prixCession: item.prixCession || "",
    datedEffet: item.datedEffet ? item.datedEffet.split("T")[0] : "",
    sort: item.sort || "",
    clause: item.clause || "",
    status: item.status || "",
    dueDate: item.dueDate ? item.dueDate.split("T")[0] : "",
    priority: item.priority || "",
    coefficient: item.coefficient || "",
    commentaire: item.commentaire || "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClauseChange = (e) => {
    const { value, checked } = e.target;
    const current = formData.clause ? formData.clause.split(" - ") : [];
    const updated = checked
      ? [...current, value]
      : current.filter((c) => c !== value);
    setFormData((prev) => ({
      ...prev,
      clause: updated.join(" - "),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    try {
      const res = await authFetch(`https://backend-myalfa.vercel.app/api/droitsoc/${item.id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (!res.ok) throw new Error("Erreur lors de la modification");
    } catch (error) {
      console.error(error);
      dialog.alert("Erreur lors de la modification");
    } finally {
      onClose();
    }
    fetchData();
  };

  return (
    <div className="w-full px-8 ">
      <div className="flex items-center gap-3 pb-3 border-b mt-5">
        <div className="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center">
          <Building2 className="w-4 h-4 text-emerald-600" />
        </div>
        <h3
          className="text-lg font-semibold text-slate-900 leading-none"
          style={{ margin: 0 }}
        >
          Cession de droit sociaux
        </h3>
      </div>
      <form onSubmit={handleSubmit}>
        <br />
        <div className="bg-gradient-to-br from-[#9B1B5D]/5 via-white to-transparent rounded-xl p-5 border-2 border-[#9B1B5D]/20">
          {/* Titre */}
          <h4 className="text-sm font-bold text-[#9B1B5D] mb-4 flex items-center gap-2">
            <AlertCircle className="w-4 h-4" />
            Informations essentielles
          </h4>
          <div className="space-y-4">
            <div className="mt-3">
              <label className="text-sm font-medium text-slate-700">
                Cédant :
              </label>
              <input
                type="text"
                name="cedant"
                className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.cedant
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
                value={formData.cedant}
                onChange={handleChange}
              />
            </div>
            <div className="mt-3">
              <label className="text-sm font-medium text-slate-700">
                Cessionnaire :
              </label>
              <input
                type="text"
                name="cessionnaire"
                className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.cessionnaire
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
                value={formData.cessionnaire}
                onChange={handleChange}
              />
            </div>
            <div className="mt-3">
              <label className="text-sm font-medium text-slate-700">
                nombre de droit :
              </label>
              <input
                type="text"
                name="nombreDeDroit"
                className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.nombreDeDroit
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
                value={formData.nombreDeDroit}
                onChange={handleChange}
              />
            </div>
            <div className="mt-3">
              <label className="text-sm font-medium text-slate-700">
                Prix de Cession
              </label>
              <input
                type="text"
                name="prixCession"
                className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.prixCession
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
                value={formData.prixCession}
                onChange={handleChange}
              />
            </div>
            <div className="mt-3">
              <label className="text-sm font-medium text-slate-700">
                {" "}
                Date d'effet :
              </label>
              <input
                type="date"
                name="datedEffet"
                className={`
                  mt-2
                  h-11
                  w-full
                  rounded-md
                  bg-white
                  px-3
                  text-sm
                  border-2
                  outline-none
                  transition-all
                  ${
                    formData.datedEffet
                      ? "border-emerald-300 focus:border-emerald-400"
                      : "border-slate-300 focus:border-slate-400"
                  }
                `}
                value={formData.datedEffet}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className="bg-slate-50 rounded-xl p-4 border border-slate-200 mt-4">
          <fieldset>
            <legend>Sort du compte courant d'associé :</legend>
            {[
              "Cédé - compris dans le prix",
              "Cédé - au nominal en dehors du prix",
              "Non cédé",
            ].map((opt) => (
              <label key={opt} style={{ display: "block" }}>
                <input
                  type="radio"
                  name="sort"
                  value={opt}
                  checked={formData.sort === opt}
                  onChange={handleChange}
                />
                {opt}
              </label>
            ))}
          </fieldset>
          <br />
          {/* Clauses */}
          <fieldset>
            <legend>Clauses :</legend>
            {[
              "Clause de garantie d’actif et de passif (GAP)",
              "Exclusion de garantie",
              "Clause d'earn-out",
              "Clause de non concurrence",
              "Clause de coopération ou d’accompagnement",
              "Clause de conditions suspensives",
            ].map((clauseOption) => (
              <label key={clauseOption} style={{ display: "block" }}>
                <input
                  type="checkbox"
                  value={clauseOption}
                  checked={formData.clause.split(" - ").includes(clauseOption)}
                  onChange={handleClauseChange}
                />
                {clauseOption}
              </label>
            ))}
          </fieldset>
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700 mt-4 block">
            Commentaire :
          </label>
          <textarea
            name="commentaire"
            rows={4}
            value={formData.commentaire}
            onChange={handleChange}
            placeholder="Précisions..."
            className="w-full rounded-md border-2 border-slate-300 px-3 py-2 text-sm bg-white outline-none focus:border-emerald-400 transition-all"
          />
        </div>
        {/* ToDo */}
        {/* <fieldset>
        <legend>Nature :</legend>
        {["Comptable", "Administratif", "Juridique", "Social"].map((n) => (
          <label key={n} style={{ marginRight: "10px" }}>
            <input
              type="radio"
              name="nature"
              value={n}
              checked={formData.nature === n}
              onChange={handleChange}
            />
            {n}
          </label>
        ))}
      </fieldset> */}
        <div className="grid grid-cols-4 gap-3 mt-5">
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Echéance{" "}
            </label>
            <input
              name="dueDate"
              type="date"
              value={formData.dueDate}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.dueDate
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            />
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Priorité
            </label>
            <select
              name="priority"
              value={formData.priority}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.priority
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            >
              <option value="classique">Classique</option>
              <option value="élevé">Élevé</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Status
            </label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.status
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            >
              <option value="En attente">En attente</option>
              <option value="En attente informations / documents">
                En attente informations / documents
              </option>
              <option value="En attente interne">En attente interne</option>
              <option value="Dépôt de capital en cours">
                Dépôt de capital en cours
              </option>
              <option value="Rédaction">Rédaction</option>
              <option value="Supervision">Supervision</option>
              <option value="Signature">Signature</option>
              <option value="Signature en cours">Signature en cours</option>
              <option value="Formalité">Formalité</option>
              <option value="Formalité déposée">Formalité déposée</option>
              <option value="Formalité à régulariser">
                Formalité à régulariser
              </option>
              <option value="Formalité rejetée">Formalité rejetée</option>
              <option value="Bloqué">Bloqué</option>
              <option value="Abandonné">Abandonné</option>
              <option value="Terminé">Terminé</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-700 flex items-center gap-1">
              Coefficient
            </label>
            <input
              name="coefficient"
              type="text"
              value={formData.coefficient}
              onChange={handleChange}
              className={`
                mt-2
                h-11
                w-full
                rounded-md
                bg-white
                px-3
                text-sm
                border-2
                outline-none
                transition-all
                ${
                  formData.coefficient
                    ? "border-emerald-300 focus:border-emerald-400"
                    : "border-slate-300 focus:border-slate-400"
                }
              `}
            />
          </div>
        </div>
        <br />
        <div className="sticky bottom-0 bg-white border-t mt-4 px-8 py-4 flex items-center justify-between">
          <button
            type="button"
            variant="outline"
            onClick={onClose}
            className={`
              px-8
              h-11
              border-2
              border-slate-300
              text-slate-700
              rounded-md
              font-medium
              hover:bg-slate-100
              transition-colors
            `}
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className={`
w-1/2
h-11
${
  isSubmitting
    ? "bg-gray-400 cursor-not-allowed"
    : "bg-[#9B1B5D] hover:bg-[#7A1548]"
}
text-white
text-base
font-medium
rounded-md
shadow-lg shadow-[#9B1B5D]/20
transition-colors
flex items-center justify-center
gap-2
`}
          >
            {isSubmitting ? (
              <>
                <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                Modification en cours...
              </>
            ) : (
              <>
                <Check className="w-5 h-5 mr-2" />
                Modifier la mission
              </>
            )}
          </button>
        </div>
        <br />
        <br />
      </form>
    </div>
  );
};

export default ModifDroitSoc;
